import { useLocation } from "react-router";
import t from "../locales/";
import CATEGORIES from "../data/categories";

const Header = () => {
  const { pathname } = useLocation();
  const category = CATEGORIES[pathname.split("/")[1]];

  return (
    <header className="header">
      {category?.header?.title ?? t("header.title")}
    </header>
  );
};

export default Header;
